import images from "@/assets/images";
import Constants from "@/constants";
import { Popup } from "antd-mobile";
import classNames from "classnames";
import React from "react";

interface IHeaderBarProps {
  tabList: typeof Constants.TAB_LIST;
  curTab: Constants.ETabKey;
  setCurTab: (tab: Constants.ETabKey) => void;
}
const HeaderBar: React.FC<IHeaderBarProps> = props => {
  const [visible, setVisible] = React.useState(false);
  return (
    <>
      <div className="flex items-center justify-between px-[24px] py-[8px]">
        <img
          src={images.hyLogo}
          className="h-[24px] w-[81px] cursor-pointer"
          onClick={() => {
            window.open("https://www.huya.com/");
          }}
        />
        <img
          src={images.iconMore}
          className="h-[24px] w-[24px]"
          onClick={() => {
            setVisible(true);
          }}
        />
      </div>
      <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
        onClose={() => {
          setVisible(false);
        }}
        position="top"
        bodyStyle={{
          background: "transparent",
        }}
        maskStyle={{
          background: "transparent",
        }}
      >
        <div
          className="h-[234px] px-[16px] py-[28px]"
          style={{
            background: `linear-gradient(180deg, #0B0B0B 90.63%, rgba(11, 11, 11, 0.00) 100%)`,
          }}
        >
          <div className="flex items-center justify-between px-[24px] py-[8px]">
            <img src={images.hyLogo} className="h-[24px] w-[81px]" />
            <img
              src={images.iconClose}
              className="h-[24px] w-[24px]"
              onClick={() => {
                setVisible(false);
              }}
            />
          </div>
          <div className="mt-[21px] px-[20px]">
            {props.tabList.map(item => {
              return (
                <div
                  key={item.key}
                  className={classNames(
                    "mb-[20px] text-[14px] font-[500] leading-[18px] last-of-type:mb-0",
                    item.key === props.curTab ? "text-[#FFE44D]" : "text-[#FFFFFF66]",
                  )}
                  onClick={() => {
                    props.setCurTab(item.key);
                    setVisible(false);
                  }}
                >
                  {item.label}
                </div>
              );
            })}
          </div>
        </div>
      </Popup>
    </>
  );
};

export default HeaderBar;
